import { render, staticRenderFns } from "./ConfirmationSource.vue?vue&type=template&id=7c16133c"
import script from "./ConfirmationSource.vue?vue&type=script&lang=js"
export * from "./ConfirmationSource.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports